import { render } from "./ModalKpiChat.vue?vue&type=template&id=1571acc6&scoped=true"
import script from "./ModalKpiChat.vue?vue&type=script&lang=js"
export * from "./ModalKpiChat.vue?vue&type=script&lang=js"

import "./ModalKpiChat.vue?vue&type=style&index=0&id=1571acc6&scoped=true&lang=css"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1571acc6"]])

export default __exports__